<template>
    <CModal :title="dialogTitle" :show.sync="dialogVisible">
        <CForm slot="default">
            <CInput
                v-model="model.title"
                :horizontal="true"
                label="Название"
                placeholder="Название категории"
            />

            <CInput
                v-model="model.parent_id"
                :horizontal="true"
                label="Родительская категория"
                placeholder="Родительская категория (необязательно)"
            />

            <CInput
                v-model="model.external_id"
                :horizontal="true"
                label="Внешний ID"
                placeholder="Внешний ID (необязательно)"
            />

            <div class="flex items-center mt-2">
                <div class="w-3/12 col-form-label">Изображение</div>
                <div class="w-9/12 col-form-label">
                    <CInputFile
                        ref="picture"
                        horizontal
                        @change="selectPicture" />
                    <CImg
                        v-if="model.picture"
                        :src="pictureUrl(model.picture)"
                        class="m2"
                        width="300" />
                </div>
            </div>

            <CTextarea
                v-model="model.description"
                :is-valid="model.description && model.description.length ? model.description.length <= 255 : undefined"
                :rows="5"
                horizontal
                label="Краткое описание"
                placeholder="Укажите краткое описание (не более 255 символов)"
            />

            <div class="flex items-center mt-2">
                <div class="w-3/12 col-form-label">Алкоголь</div>
                <div class="w-9/12 col-form-label">
                    <CSwitch
                        color="success"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="model.is_alcohol"
                    />
                </div>
            </div>

            <div class="flex items-center mt-2">
                <div class="w-3/12 col-form-label">Программа лояльности</div>
                <div class="w-9/12 col-form-label">
                    <CSwitch
                        color="success"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="model.loyalty"
                    />
                </div>
            </div>


            <div class="flex items-center mt-2">
                <div class="w-3/12 col-form-label">Активен</div>
                <div class="w-9/12 col-form-label">
                    <CSwitch
                        color="success"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="model.enabled"
                    />
                </div>
            </div>
        </CForm>

        <div slot="footer">
            <CButton
                color="light"
                class="ml-3"
                @click="close">Отмена</CButton>

            <CButton
                color="primary"
                class="ml-3"
                @click="submit">{{
                    submitButtonTitle
                }}</CButton>
        </div>
    </CModal>
</template>

<script>
    export default {
        name: 'GrocerCategoryUpsertDialog',

        props: {
            entity: {
                type: Object,
                default: () => ({}),
            },
        },

        data: () => ({
            dialogVisible: false,
            model: {
                enabled: true
            },
        }),

        computed: {
            dialogTitle() {
                return typeof this.entity.id === 'number'
                    ? 'Редатирование категории'
                    : 'Создание категории';
            },

            submitButtonTitle() {
                return typeof this.entity.id === 'number' ? 'Сохранить' : 'Создать';
            },
        },

        watch: {
            dialogVisible: function (v) {
                if (v) {
                    this.setModel(this.entity);
                }
            },
        },

        methods: {
            open() {
                this.dialogVisible = true;
            },

            close() {
                this.dialogVisible = false;
            },

            setModel(source) {
                this.model = source;
            },

            async submit() {
                if (!this.model.title) {
                    this.$root.$emit('showError', 'Название категории не может быть пустым.');
                    return;
                }

                try {
                    const { id, ...payload } = this.model;

                    if (typeof id === 'number') {
                        await this.axios.put(
                            `/grocers/${payload.grocer_id}/categories/${id}`,
                            payload
                        );
                    } else {
                        await this.axios.post(
                            `/grocers/${payload.grocer_id}/categories`,
                            payload
                        );
                    }

                    this.$emit('success');
                    this.close();
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка создания/редактирования категории. ' + err);
                }
            },

            async selectPicture(FileList) {
                // Загружаем картинку
                if (FileList[0]) {
                    let formData = new FormData();
                    formData.append('file', FileList[0]);
                    let { data } = await this.axios.post('/files/upload', formData);
                    if (data && data.filename) {
                        this.model.picture = data.filename;
                    }
                }
            },

            pictureUrl(picture) {
                if (this.model.picture) {
                    return process.env.VUE_APP_STATIC_BASE_URL + '/' + picture;
                } else {
                    return false;
                }
            },
        },
    };
</script>
